import type { CustomView } from "@/features/inbox/types/custom-view";
import type { Lifecycle } from "@/types/lifecycle";
import type { Tag } from "@/types/tag";

import { createId, createPastTimestamp } from "./base";

import { CUSTOM_VIEW_VISIBILITY } from "@/features/inbox/types/custom-view";

export function generateCustomViews(
  createdBy: string,
  tags: Tag[],
  lifecycles: Lifecycle[],
): CustomView[] {
  const inboxes: CustomView[] = [];

  if (tags.length > 0) {
    inboxes.push({
      id: createId(),
      name: "VIP patients",
      icon: "⭐",
      query: {
        id: createId(),
        rules: [
          {
            id: createId(),
            field: "tags",
            operator: "hasAnyOf",
            value: [tags[0].id],
          },
        ],
      },
      visibility: CUSTOM_VIEW_VISIBILITY.PRIVATE,
      createdBy,
      createdAt: createPastTimestamp(20),
      updatedAt: null,
    });
  }

  if (lifecycles.length > 0) {
    inboxes.push({
      id: createId(),
      name: "New leads",
      icon: "🌱",
      query: {
        id: createId(),
        rules: [
          {
            id: createId(),
            field: "lifecycle",
            operator: "hasAnyOf",
            value: [lifecycles[0].id],
          },
        ],
      },
      visibility: CUSTOM_VIEW_VISIBILITY.WORKSPACE,
      createdBy,
      createdAt: createPastTimestamp(12),
      updatedAt: createPastTimestamp(3),
    });
  }

  return inboxes;
}
